"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Used as FC primary color
 * Palette generated based on the FC main charcoal color with http://mcg.mbitson.com/#!?straitfromhere=%23202020
 * https://material.io/color/#!/?view.left=0&view.right=0 used for finding the accent colors
 */
const Charcoal = {
    50: "#EAEAEA",
    100: "#CACACA",
    200: "#A7A7A7",
    300: "#838383",
    400: "#696969",
    500: "#4E4E4E",
    600: "#474747",
    700: "#3D3D3D",
    800: "#353535",
    900: "#252525",
    A100: "#D8D8D8",
    A200: "#7A7A7A",
    A400: "#4E4E4E",
    A700: "#262626",
};
exports.default = Charcoal;
